import axiosInstance from './api';

export const getAllSubcategories = () => axiosInstance.get('/subcategory');

export const createSubcategory = (name, categories) =>
  axiosInstance.post('/subcategory', { name, categories });

export const updateSubcategory = (id, name, categories) =>
  axiosInstance.put(`/subcategory/${id}`, { name, categories });

export const deleteSubcategory = (id) =>
  axiosInstance.delete(`/subcategory/${id}`);

export const getSubcategoriesByCategory = (categoryId) =>
  axiosInstance.get(`/subcategory/by-category/${categoryId}`);

export const getCategoryOfSubcategory = (subcategoryId) =>
  axiosInstance.get(`/subcategory/category-of/${subcategoryId}`);

export const importSubcategoriesFromExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post('/subcategory/import-excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
